'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { Record, Map as ImmutableMap, fromJS } from 'immutable';
var defaults = {
  linkAvailabilityByDuration: ImmutableMap()
};

var LinkAvailability = /*#__PURE__*/function (_Record) {
  _inherits(LinkAvailability, _Record);

  function LinkAvailability() {
    _classCallCheck(this, LinkAvailability);

    return _possibleConstructorReturn(this, _getPrototypeOf(LinkAvailability).apply(this, arguments));
  }

  _createClass(LinkAvailability, null, [{
    key: "from",
    value: function from(json) {
      return new LinkAvailability({
        linkAvailabilityByDuration: fromJS(json && json.linkAvailabilityByDuration)
      });
    }
  }]);

  return LinkAvailability;
}(Record(defaults));

export { LinkAvailability as default };